// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "8be3e30/js/" + chunkId + ".js";
};